import create from 'zustand'
import { CascaderOptionType } from 'antd/lib/cascader'
import { GroupedCompanyWithLegalEntitiesAndCountries, Country } from '../../types'
import { ScoreGridsStoreState } from './ScoreGridsStoreState'

const initialValues = {
  storeInitialized: false,
  companiesAndCountries: [],
  companiesAndCountriesSelected: [],
  selected: { companyId: '', country: '' as Country },
  isProcessingExport: false,
}

export const useScoreGridsStore = create<ScoreGridsStoreState>((set) => ({
  ...initialValues,

  initStore: (companiesAndCountries: GroupedCompanyWithLegalEntitiesAndCountries[]) =>
    set((state) => {
      const companiesAndCountriesSelected: CascaderOptionType[] = companiesAndCountries.map((company) => ({
        label: company.companyName,
        value: `${company.companyId}`,
        children: Array.from(new Set(company.companyCountries.map((countryAndLegalEntity) => countryAndLegalEntity.country))).map(
          (country) => ({
            label: country,
            value: `${country}`,
          }),
        ),
      }))

      const selected = {
        companyId: state.selected.companyId || companiesAndCountries[0].companyId,
        country: state.selected.country || (companiesAndCountries[0].companyCountries[0].country as Country),
      }

      return { companiesAndCountries, companiesAndCountriesSelected, selected, storeInitialized: true }
    }),

  resetStore: () => set({ ...initialValues }),
  setSelected: (companyId: string, country: Country) => set({ selected: { companyId, country } }),
  setIsProcessingExport: (value: boolean) => set({ isProcessingExport: value }),
}))
